import Page from './index';
import { authRoles } from 'app/auth';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	auth: authRoles.adminAgent,
	routes: [
		{
			path: '/customer-management',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/service-tickets/focus-details',
			exact: true,
			component: Page.FocusModeDetails
		},
		{
			path: '/service-tickets/:id',
			exact: true,
			component: Page.Details
		},
	]
};